/**
 * Base class for anything the world updates. A mesh is optional (useful for
 * invisible triggers or purely logical entities), as is a physics body.
 */
export class Entity {
  constructor({ mesh = null, body = null } = {}) {
    this.mesh = mesh;
    this.body = body;
    this.world = null;
  }

  fixedUpdate(_dt) {}

  lateUpdate(_dt) {}
}
